<h2 mat-dialog-title>Confirm Deletion</h2>

<mat-dialog-content>
    Tem a certeza que pretende apagar "{{ data.tagName }}"?
</mat-dialog-content>

<mat-dialog-actions
    align="end"
    class="p-4 flex items-center justify-end space-x-4"
>
    <!-- Botão "Cancelar" com estilo "stroked" do Material e classes Tailwind -->
    <button
        mat-stroked-button
        (click)="onCancel()"
        class="px-4 py-2 font-medium"
    >
        Cancelar
    </button>

    <!-- Botão "Apagar" com estilo "flat" do Material e cor "warn" -->
    <button
        mat-flat-button
        color="warn"
        (click)="onConfirm()"
        class="px-4 py-2 font-medium"
    >
        Apagar
    </button>
</mat-dialog-actions>
